import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2;
import { action, computed, observable, runInAction } from 'mobx';
import MetricDeviceCollection from 'app/stores/metrics/MetricDeviceCollection';
import $auth from 'app/stores/$auth';
import $app from 'app/stores/$app';
import { modelFinder } from 'app/stores/util/modelFinder';
import { api } from 'core/util';
import $devices from '../device/$devices';
let MetricsDevicesStore = (_dec = observable.ref, _class = class MetricsDevicesStore {
  constructor() {
    this.collection = new MetricDeviceCollection();
    _initializerDefineProperty(this, "initializePromise", _descriptor, this);
    _initializerDefineProperty(this, "initialized", _descriptor2, this);
  }
  initialize() {
    return this.setup();
  }
  destroy() {
    this.initializePromise = undefined;
    this.initialized = false;
  }
  setup() {
    if (!this.initializePromise) {
      if ($auth.hasPermission('recon.enabled', {
        overrideForSudo: false
      }) && $app.isSharedLink && !$app.isSubtenant) {
        this.initializePromise = this.collection.fetch().then(results => {
          this.initialized = true;
          return results;
        });
      } else {
        this.initialized = true;
      }
    }
    return this.initializePromise || Promise.resolve();
  }

  /**
   * This is only private to make test mocks easier.
   */
  get _byIp() {
    // @ts-expect-error need to fully convert MetricDeviceModel
    return modelFinder(this.collection, 'ip_address');
  }
  byIp(ip_address) {
    return this._byIp(ip_address);
  }

  /**
   * This is only private to make test mocks easier.
   */
  get _byMacAddress() {
    // @ts-expect-error need to fully convert MetricDeviceModel
    return modelFinder(this.collection, 'mac_address');
  }
  byMacAddress(mac_address) {
    return this._byMacAddress(mac_address);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "initializePromise", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "initialized", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "destroy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "destroy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_byIp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_byIp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_byMacAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_byMacAddress"), _class.prototype), _class);
export const $metricsDevices = new MetricsDevicesStore();
export const deviceModelByName = deviceName => $metricsDevices.collection.models.find(model => {
  const modelDeviceName = `${model.get('name')}`.toLowerCase();
  const matchDeviceName = `${deviceName}`.toLowerCase();
  return modelDeviceName === matchDeviceName;
});
export const getMetricsDeviceNameFromQueryModel = ({
  device_name,
  device_ip,
  mac_address
}) => {
  if (!device_name && device_ip) {
    device_name = $metricsDevices.byIp(device_ip)?.get('name');
  }
  if (!device_name && mac_address) {
    device_name = $metricsDevices.byMacAddress(mac_address)?.get('name');
  }
  return device_name;
};
export const hasNmsDevices = computed(() => !$app.isSubtenant && ($app.isSharedLink ? $metricsDevices.collection.hasFetched && $metricsDevices.collection.unfilteredSize > 0 : $devices.hasNmsDevices));

/**
 * This gets called from the Add ICMP Devices page, but re-use the same API
 * endpoint as the Discovery page.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createIcmpDevices = (configs, collection) => runInAction(() => api.post('/api/ui/discovery/devices', {
  body: {
    devices: configs
  }
}).then(results => {
  const hasErrors = results.some(result => result.success === false);
  const failedDevices = [];
  if (hasErrors) {
    results.forEach(result => {
      const device = collection.models.find(d => d.get('address') === result.address);
      if (device) {
        device.safeSet(result);
        if (result.success === false) {
          failedDevices.push(device);
        }
      }
    });
    collection.selected = failedDevices;
    return Promise.reject();
  }
  return $metricsDevices.collection.fetch({
    force: true
  }).then(() => $devices.loadDeviceSummaries()).then(() => results);
}));